var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, IconBackground, Trans, Typography, UserIcon, } from '@lucidlink/uicore';
import { FormRoot } from '@lucidlink/uicore/form-builder';
import { useDeleteGuestLinkAcl } from '../../../../query-hooks/mutations/useDeleteGuestLinkAcl';
import { useGetGuestLink } from '../../../../query-hooks/queries/useGetGuestLink';
import { AddGuestForm } from './AddGuestForm';
import { GuestEntry } from './GuestEntry';
export const GuestsTab = ({ filespaceId, guestLinkId, workspaceId, }) => {
    _react_refresh_temp_2();
    const { data } = useGetGuestLink({ filespaceId, workspaceId }, guestLinkId);
    const { mutate: deleteGuestLinkAcl } = useDeleteGuestLinkAcl({
        filespaceId,
        workspaceId,
    });
    const sortedAcl = useMemo(() => (data?.guestLinkAcl ?? []).toSorted((a, b) => a.email.localeCompare(b.email)), [data?.guestLinkAcl]);
    if (!data) {
        return null;
    }
    return (_jsxs(Box, { gap: "m", isFullHeight: true, orientation: "vertical", children: [_jsx(FormRoot, { "data-testid": "add-guest-form", children: _jsx(AddGuestForm, { filespaceId: filespaceId, guestLinkId: guestLinkId, workspaceId: workspaceId }) }), sortedAcl.length > 0 ? (_jsx(Box, { orientation: "vertical", children: sortedAcl.map((acl) => {
                    return (_jsx(GuestEntry, { email: acl.email, filespaceId: filespaceId, isOptimistic: acl.isOptimistic, onRemove: () => deleteGuestLinkAcl({
                            guestLinkId,
                            email: acl.email,
                        }), workspaceId: workspaceId }, acl.email));
                }) })) : (_jsxs(Box, { align: "center", gap: "m", grow: 1, isFullHeight: true, justify: "center", orientation: "vertical", children: [_jsx(IconBackground, { "data-testid": "workspace-requiring-full-login", Icon: UserIcon }), _jsx(Typography, { kind: "p-small", children: _jsx(Trans, { children: "Guests have read-only access and are free." }) })] }))] }));
};
_react_refresh_temp_1 = GuestsTab;
$RefreshReg$(_react_refresh_temp_1, "GuestsTab");
_react_refresh_temp_2(GuestsTab, "3atVa6C2GhUTgeUDsYENDM7SHgY=", false, () => [useGetGuestLink, useDeleteGuestLinkAcl]);
